import React, { ReactElement } from 'react';

function StopHandIcon(): ReactElement {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13.7" height="17.3">
            <path
                fill="currentColor"
                d="M7.8 0a1.1 1.1 0 00-1 1v.5a1.2 1.2 0 00-2.2.8l-.2 8-2-1.8a1.5 1.5 0 00-2.4.7.3.3 0 000 .3l2 4a8.4 8.4 0 001 1.3l1.3 1.6a2.4 2.4 0 001.9.9h4.6a2.4 2.4 0 002.4-1.7l.3-1.1a5.6 5.6 0 00.2-2l-.4-8.4a1.2 1.2 0 00-2.2-.7V2.3A1.2 1.2 0 009 1.5V1A1.1 1.1 0 007.7 0zm0 .5a.6.6 0 01.6.6l.2 7a.3.3 0 00.3.3.3.3 0 00.3-.3V2.3a.7.7 0 011.4 0l.1 5.8a.3.3 0 00.3.3.3.3 0 00.3-.3V4.2a.7.7 0 011.4 0l.5 8.4a5.1 5.1 0 01-.2 1.7l-.4 1.1a1.9 1.9 0 01-1.8 1.4H6.2a1.9 1.9 0 01-1.5-.7l-1.3-1.6a7.9 7.9 0 01-.8-1.3l-2-3.9A1 1 0 012 9l2.3 2v.7a.3.3 0 00.2.3.3.3 0 00.3-.3l.2-9.4a.7.7 0 011.4 0v5.8a.3.3 0 00.3.3A.3.3 0 007 8l.2-7a.6.6 0 01.5-.6zm-1 9.5a.3.3 0 00-.3.2v.6a.3.3 0 10.5 0v-.6a.3.3 0 00-.2-.2zM8 10a.3.3 0 00-.2.2v.6a.3.3 0 00.5 0v-.6a.3.3 0 00-.3-.2zm1.4 0a.3.3 0 00-.3.2v.6a.3.3 0 00.5 0v-.6a.3.3 0 00-.2-.2zm1.3 0a.3.3 0 00-.2.2v.6a.3.3 0 00.5 0v-.6a.3.3 0 00-.3-.2z"
            />
        </svg>
    );
}

export default StopHandIcon;
